/* Progressive enhancement: the full photo remains visible without JavaScript. */
if (!customElements.get('fe-teen-box-gallery')) {
  customElements.define('fe-teen-box-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const controls = this.querySelector('[data-box-views]');
      const image = this.querySelector('.fe-teen-box__frame img');
      if (!controls || !image) return;
      const enable = () => { controls.hidden = false; };
      if (image.complete && image.naturalWidth) enable();
      else image.addEventListener('load', enable, { once: true, signal });
      controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-box-view]');
        if (!button || !controls.contains(button)) return;
        this.dataset.view = button.dataset.boxView;
        controls.querySelectorAll('button').forEach(item => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        this.querySelector('[data-box-status]').textContent = button.textContent.trim();
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
